export default __webpack_public_path__ + "static/product1-5add1872cf11a4fae55d606dadb05eb8.png";